import React from "react";

function ListCategories() {
  return <div></div>;
}

export default ListCategories;
